import { createModalManager, ModalStateType } from 'components';
import MaterialDownloadModal, { MaterialDownloadModalProps } from 'modules/material/MaterialDownloadModal';
import { CopyMaterialByCaseLocationModalProps } from 'modules/material/CopyMaterialByCaseLocationModal';

type ModalMapType =
  | ModalStateType<'order.new.confirm', Record<string, never>>
  | ModalStateType<'order.new.leave.confirm', Record<string, never>>
  | ModalStateType<
      | 'material.archive'
      | 'material.link.remove'
      | 'material.document.remove'
      | 'users.invite.remove'
      | 'order.new.copyright.alert'
      | 'material.recreate'
      | 'users.revoke.access'
      | 'tasks.book.confirmed'
      | 'order.new.successful'
    >
  | ModalStateType<'material.download', MaterialDownloadModalProps>
  | ModalStateType<'material.location.copy', CopyMaterialByCaseLocationModalProps>;

const { Provider, useShowModal } = createModalManager(({ id, params }: ModalMapType) => {
  switch (id) {
    case 'material.download':
      return <MaterialDownloadModal {...(params as MaterialDownloadModalProps)} />;
    default:
      return null;
  }
});

export { useShowModal };

export default { Provider };
